import React, { useMemo } from 'react';

function SlashedPrice(props) {
  const { oldPrices, program, index } = props;
  const { details, amount } = oldPrices?.[index] || {};

  const slashedPrice = useMemo(() => {
    const hasFee = details?.fee !== undefined;
    if (program?.amount === 0 || program?.details?.recurringAmount === 0) {
      return null;
    }

    if ((amount > program?.amount) && !hasFee) {
      return amount;
    }

    if (hasFee && ((amount - details?.fee) > (program?.amount - details?.fee))) {
      return amount - details?.fee;
    }

    if (details?.recurringAmount > program?.details?.recurringAmount) {
      return details?.recurringAmount;
    }

    return null;
  }, [amount, details, program]);

  if (!slashedPrice) {
    return null;
  }

  return (
    <small className="discount">${slashedPrice}</small>
  );
}

export default SlashedPrice;

